export const PASSWORD_STATE_EVENTS = {
    VIEW_SIGNUP_AFTER_LOGIN_UNREGISTERED: "view_signup_after_login_unregistered",
 } as const;